import { defineComponent as e } from "vue";
const s = {
  primary: {
    underlayClasses: "bg-primary-200 dark:bg-primary-900",
    progressClasses: "bg-primary-500"
  },
  accent: {
    underlayClasses: "bg-accent-200 dark:bg-accent-900",
    progressClasses: "bg-accent-500"
  },
  indigo: {
    underlayClasses: "bg-indigo-200 dark:bg-indigo-900",
    progressClasses: "bg-indigo-500"
  },
  red: {
    underlayClasses: "bg-red-200 dark:bg-red-900",
    progressClasses: "bg-red-500"
  },
  orange: {
    underlayClasses: "bg-orange-200 dark:bg-orange-900",
    progressClasses: "bg-orange-500"
  },
  teal: {
    underlayClasses: "bg-teal-200 dark:bg-teal-900",
    progressClasses: "bg-teal-500"
  },
  purple: {
    underlayClasses: "bg-purple-200 dark:bg-purple-900",
    progressClasses: "bg-purple-500"
  },
  pink: {
    underlayClasses: "bg-pink-200 dark:bg-pink-900",
    progressClasses: "bg-pink-500"
  },
  yellow: {
    underlayClasses: "bg-yellow-200 dark:bg-yellow-900",
    progressClasses: "bg-yellow-500"
  },
  green: {
    underlayClasses: "bg-green-200 dark:bg-green-900",
    progressClasses: "bg-green-500"
  },
  gray: {
    underlayClasses: "bg-zinc-200 dark:bg-zinc-600",
    progressClasses: "bg-zinc-400"
  }
}, a = e({
  name: "TuiProgressLinear",
  props: {
    value: {
      type: [Number, String],
      default: void 0
    },
    color: {
      type: String,
      default: "primary"
    },
    indeterminate: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    spec() {
      return s[this.color];
    },
    progressStyles() {
      return {
        width: `${this.value}%`
      };
    }
  }
});
export {
  a as default
};
//# sourceMappingURL=ProgressLinear.vue2.mjs.map
